import { createClientContract } from '../../../graphql/custom_mutations';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const addClientContract = async (props) => {
  if (!props) return;

  try {
    const response = await client.graphql({
      query: createClientContract,
      variables: { input: props },
    });

    const results = response.data.createSpkClientContractTbl;
    return results;
  } catch (err) {
    return ('error addClientContract: ', [err]);
  }
};

addClientContract.propTypes = {
  props: PropTypes.object.isRequired,
};
